/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type WebhookDataAccountDisconnected = {
  accountID: string;
  foreignID?: string | undefined;
};

/** @internal */
export const WebhookDataAccountDisconnected$inboundSchema: z.ZodType<
  WebhookDataAccountDisconnected,
  z.ZodTypeDef,
  unknown
> = z.object({
  accountID: z.string(),
  foreignID: z.string().optional(),
});
/** @internal */
export type WebhookDataAccountDisconnected$Outbound = {
  accountID: string;
  foreignID?: string | undefined;
};

/** @internal */
export const WebhookDataAccountDisconnected$outboundSchema: z.ZodType<
  WebhookDataAccountDisconnected$Outbound,
  z.ZodTypeDef,
  WebhookDataAccountDisconnected
> = z.object({
  accountID: z.string(),
  foreignID: z.string().optional(),
});

export function webhookDataAccountDisconnectedToJSON(
  webhookDataAccountDisconnected: WebhookDataAccountDisconnected,
): string {
  return JSON.stringify(
    WebhookDataAccountDisconnected$outboundSchema.parse(
      webhookDataAccountDisconnected,
    ),
  );
}
export function webhookDataAccountDisconnectedFromJSON(
  jsonString: string,
): SafeParseResult<WebhookDataAccountDisconnected, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => WebhookDataAccountDisconnected$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'WebhookDataAccountDisconnected' from JSON`,
  );
}
